import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultFieldOfStudyPage from './Pages/DefaultFieldOfStudyPage';
import WizardPage from './Pages/WizardPage';

const FieldOfStudyRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:fieldOfStudyId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultFieldOfStudyPage />
            </Route>
        </Switch>
    );
};

export default FieldOfStudyRouter;
